import React, { useState } from 'react'
import FsLightbox from 'fslightbox-react';

import easyOperateimg1 from "../assets/images/index/operate/img-01.png";
import introImg from "../assets/images/3bids-intro.jpg";
import introVideo from "../assets/videos/3bids-intro-video.mp4";

export default function HowItWorks() {

    const [toggler, setToggler] = useState(false);

    return (
        <>
            <section className="bds-sectionmid my-5">
                <div className="bds-easyrightarea row">
                    <figure className="col-lg-6">
                        <img
                            src={easyOperateimg1}
                            alt="image-description"
                            width={100}
                            height={100}
                            layout="fixed"
                        />
                        <figcaption className="bds-imgdescp">
                            <div className="bds-rightareainfo">
                                <button
                                    className="bds-themegallery btn btn-link text-decoration-none"
                                    onClick={() => setToggler(!toggler)}
                                >
                                    <i className="icon-play bds-playicon"></i>
                                </button>
                                <FsLightbox
                                    toggler={toggler}
                                    sources={[
                                        introVideo
                                    ]}
                                    className="w-100"
                                />
                                <h3>See how we’re making change</h3>
                                <h5>An official introduction to our work process</h5>
                            </div>
                        </figcaption>
                    </figure>
                    <div className="bds-easyoperate col-lg-6">
                        <div className="bds-maintitle">
                            <h2>It’s easy to operate</h2>
                        </div>
                        <div className="bds-easyinfo">
                            <div className="bds-easyinfotitle">
                                <i className="icon-user-check bds-iconcircle"></i>
                                <div className="bds-easyitem">
                                    <h4>Post Your Task</h4>
                                    <p>
                                        Post the service you need. We will get your job to nearby freelancers.
                                    </p>
                                </div>
                            </div>
                            <div className="bds-easyinfotitle">
                                <i className="icon-briefcase bds-iconcircle bds-bgred"></i>
                                <div className="bds-easyitem">
                                    <h4>Review Offers</h4>
                                    <p>
                                        Contractors bid on your job. You can review and accept the one that best matches. 
                                    </p>
                                </div>
                            </div>
                            <div className="bds-easyinfotitle">
                                <i className="icon-star bds-iconcircle bds-bgyellow"></i>
                                <div className="bds-easyitem">
                                    <h4>Give Feedback</h4>
                                    <p>
                                        Get your work done and give Feedback 
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
